import React from "react";
import { COMPANY } from "@/lib/apiClient";

const T = {
  line: "#2a8c9c",
  head: "#a5dde5",
  text: "#0f5f6d",
};

const rp = (v) => (Number(v || 0) ? `Rp ${Number(v).toLocaleString("id-ID")}` : "");

const cell = (extra = {}) => ({
  border: `1px solid ${T.line}`,
  padding: "3px 5px",
  fontSize: 10,
  height: 18,
  ...extra,
});

const headCell = {
  border: `1px solid ${T.line}`,
  background: T.head,
  color: T.text,
  fontWeight: 700,
  fontSize: 10,
  padding: "5px 4px",
  textAlign: "center",
  letterSpacing: 0.3,
};

const SheetHeader = ({ nomor, tanggal, client, label }) => (
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10 }}>
    <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
      <img src={COMPANY.logo} alt="PAS" style={{ width: 86, height: "auto", objectFit: "contain" }} />
      <div style={{ color: T.text }}>
        <div style={{ fontSize: 20, fontWeight: 800, letterSpacing: 1 }}>PAS PERCETAKAN</div>
        <div style={{ fontSize: 12, fontWeight: 700, fontStyle: "italic" }}>
          Digital Printing &amp; Advertising
        </div>
        <div style={{ fontSize: 9, marginTop: 2 }}>
          Jl. Sultan Ageng Tirtayasa Blok Silorog Rt.02 / Rw.01
        </div>
        <div style={{ fontSize: 9 }}>Desa Kedungjaya, Kedawung, Cirebon</div>
        <div style={{ fontSize: 9 }}>
          ✉ {COMPANY.email} &nbsp;·&nbsp; {COMPANY.phone}
        </div>
      </div>
    </div>
    <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
      <div style={{ borderLeft: `3px solid ${T.line}`, paddingLeft: 8, color: T.text, fontSize: 11, fontWeight: 700 }}>
        <div style={{ height: 22, lineHeight: "22px" }}>Tanggal</div>
        <div style={{ height: 22, lineHeight: "22px" }}>Kepada YTH</div>
      </div>
      <div>
        <div style={{ border: `1px solid ${T.line}`, height: 22, minWidth: 170, padding: "0 6px", fontSize: 10, lineHeight: "22px" }}>
          {tanggal}
        </div>
        <div style={{ border: `1px solid ${T.line}`, height: 22, minWidth: 170, padding: "0 6px", fontSize: 10, lineHeight: "22px", marginTop: 4 }}>
          {client}
        </div>
        <div style={{ border: `1px solid ${T.line}`, height: 22, minWidth: 170, padding: "0 6px", fontSize: 10, lineHeight: "22px", marginTop: 10, textAlign: "center", fontWeight: 700, color: T.text }}>
          {label} {nomor}
        </div>
      </div>
    </div>
  </div>
);

/** Satu lembar faktur (nota A5 / invoice A4) bergaya cetak PAS. */
export const FakturSheet = ({
  nomor,
  label = "",
  tanggal,
  tanggalPrint,
  client,
  lines,
  rowCount,
  total,
  terbayar,
  sisa,
  showTotals = true,
  catatan = "",
  printedBy = "",
  pageInfo = "",
}) => {
  const filled = [...lines];
  while (filled.length < rowCount) filled.push(null);

  return (
    <div style={{ background: "#fff", color: "#0f172a", fontFamily: "Arial, sans-serif" }}>
      <SheetHeader nomor={nomor} label={label} tanggal={tanggalPrint} client={client} />

      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 8 }}>
        <thead>
          <tr>
            <th style={{ ...headCell, width: "13%" }}>TANGGAL</th>
            <th style={{ ...headCell, width: "37%" }}>JENIS PEKERJAAN</th>
            <th style={{ ...headCell, width: "12%" }}>UKURAN</th>
            <th style={{ ...headCell, width: "8%" }}>QTY</th>
            <th style={{ ...headCell, width: "13%" }}>HARGA/M</th>
            <th style={{ ...headCell, width: "17%" }}>JUMLAH</th>
          </tr>
        </thead>
        <tbody>
          {filled.map((l, i) => (
            <tr key={`r-${i}`}>
              <td style={cell({ textAlign: "center" })}>{l ? tanggal : ""}</td>
              <td style={cell()}>
                {l ? `${l.kategori || ""}${l.deskripsi ? ` · ${l.deskripsi}` : ""}` : ""}
              </td>
              <td style={cell({ textAlign: "center" })}>
                {l && (l.panjang || l.lebar) ? `${l.panjang || "-"} x ${l.lebar || "-"}` : ""}
              </td>
              <td style={cell({ textAlign: "center" })}>{l ? l.qty || "" : ""}</td>
              <td style={cell({ textAlign: "right" })}>{l ? rp(l.price) : ""}</td>
              <td style={cell({ textAlign: "right" })}>{l ? rp(l.nilai) : ""}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {showTotals && (
        <div style={{ display: "flex", justifyContent: "space-between", gap: 10, marginTop: 6 }}>
          <div style={{ border: `1px solid ${T.line}`, flex: 1, minHeight: 54, padding: "4px 6px", fontSize: 9 }}>
            {catatan}
          </div>
          <table style={{ borderCollapse: "collapse", width: "46%" }}>
            <tbody>
              {[["JUMLAH", total], ["DP", terbayar], ["SISA", sisa]].map(([k, v]) => (
                <tr key={k}>
                  <td style={{ ...headCell, textAlign: "left", width: "52%" }}>{k}</td>
                  <td style={cell({ textAlign: "right" })}>{rp(v)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div style={{ display: "flex", justifyContent: "space-between", gap: 12, marginTop: 14, color: T.text }}>
        <div style={{ fontSize: 10, fontWeight: 700 }}>
          Tanda Terima,
          <div style={{ borderBottom: `2px solid #1d4ed8`, width: 120, marginTop: 34 }} />
        </div>
        <div style={{ fontSize: 10, fontWeight: 700 }}>
          Hormat Kami
          <div style={{ borderBottom: `2px solid #1d4ed8`, width: 120, marginTop: 34 }} />
        </div>
        <div style={{ fontSize: 9.5, fontStyle: "italic", fontWeight: 700, maxWidth: "42%", textAlign: "right" }}>
          &quot; Sebuah Apresiasi Senyum Sudah Lebih Dari Cukup Bagi Kami Karena Di Balik Senyum Akan
          Terukir Do&apos;a Do&apos;a Baik &quot;
          <div style={{ fontStyle: "normal", fontWeight: 400, fontSize: 8.5, color: "#475569", marginTop: 6 }}>
            {pageInfo} {printedBy ? `· dicetak oleh ${printedBy}` : ""}
          </div>
        </div>
      </div>
    </div>
  );
};
